module.exports = __webpack_public_path__ + "static/image/logo-family/new_logo_connect.ver2_0_2.png?55bcd4de";